import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { AuthService, Tab } from "src/app/core";

const packagesTab = {
  key: "Packages",
  title: "SERVICES.Packages",
  routerLink: "packages",
};

const guidedToursTab = {
  key: "GuidedTours",
  title: "SERVICES.GuidedTours",
  routerLink: "guided-tours",
};

const productsTab = {
  key: "Products",
  title: "SERVICES.Products",
  routerLink: "products",
};

const tabs: Tab[] = [
  packagesTab,
  guidedToursTab,
  productsTab,
  {
    key: "VisitorPrices",
    title: "VISITOR_PRICES.TITLE",
    routerLink: "visitor-prices",
  },
  {
    key: "MuseumBuildings",
    title: "MUSEUM_BUILDINGS.TITLE",
    routerLink: "museum-buildings",
  },
  {
    key: "GroupOffers",
    title: "GROUP_OFFERS.TITLE",
    routerLink: "group-offers",
  },
  {
    key: "Halls",
    title: "HALLS.TITLE",
    routerLink: "halls",
  },
  {
    key: "AudioDevices",
    title: "AUDIO_DEVICES.TITLE",
    routerLink: "audio-devices",
  },
  {
    key: "coupons",
    title: "COUPONS.TITLE",
    routerLink: "coupons",
  },
];

export const servicesManagementResolver: ResolveFn<Tab[]> = (route, state) => {
  const isCounter = inject(AuthService).isCounter;

  if (isCounter()) return [productsTab];

  return tabs;
};
